import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Lo que más me ayudó fue empezar a ordenar mis precios y mis políticas. Antes todo dependía de lo que resolvía en el momento.',
  author: 'Laura R.',
  role: 'Profesional Independiente'
}, {
  quote: 'Me dio más estructura para atender mejor y dejar de sentir que estaba apagando incendios todo el día.',
  author: 'Mica T.',
  role: 'Lashista Profesional'
}, {
  quote: 'Solo con los scripts y las hojas de control ya empecé a sentir más orden en mi negocio.',
  author: 'Carla G.',
  role: 'Profesional Independiente'
}];
export function Testimonials() {
  return <section className="py-20 bg-white pt-[30px] pb-[30px]" data-id="element-195">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-198">
            Lo que dicen otras profesionales
          </h2>
          <p className="text-lg text-gray-600" data-id="element-199">
            Testimonios de lashistas y profesionales del rubro belleza.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-200">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream p-8 rounded-3xl border border-gray-100 flex flex-col" data-id="element-201">
              <div className="flex items-center gap-1 text-ocean-gold mb-6" data-id="element-202">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-203" />)}
              </div>

              <blockquote className="text-gray-700 text-lg leading-relaxed mb-8 flex-1" data-id="element-204">
                "{t.quote}"
              </blockquote>

              <div className="mt-auto" data-id="element-205">
                <div className="font-bold text-gray-900" data-id="element-206">{t.author}</div>
                {t.role && <div className="text-gray-500 text-sm mb-2" data-id="element-207">{t.role}</div>}
                <div className="flex items-center gap-1 text-xs text-ocean-teal font-medium" data-id="element-208">
                  <CheckCircle2 className="w-3.5 h-3.5" data-id="element-209" />
                  Compra verificada
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}